import { request } from "./client";
import type { EffectivenessReport, ReportExportCommand, ReportExportEvidence } from "./types";

function query(command: ReportExportCommand): string {
  const params = new URLSearchParams({
    advertiserId: command.advertiserId,
    campaignId: command.campaignId,
    placementId: command.placementId,
    from: command.from,
    until: command.until,
    timezone: command.timezone,
  });
  if (command.platform) params.set("platform", command.platform);
  return params.toString();
}

export const reports = {
  effectiveness: (command: ReportExportCommand) =>
    request<EffectivenessReport>(`/admin/v1/reports/effectiveness?${query(command)}`),
  createExport: (command: ReportExportCommand) =>
    request<ReportExportEvidence>("/admin/v1/reports/exports", {
      method: "POST", body: command, csrf: true,
    }),
  downloadUrl: (id: string) => `/admin/v1/reports/exports/${encodeURIComponent(id)}`,
};
